import React from 'react';
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import { connect } from 'react-redux';
 
const LoadingBar = ({ routeLoading, otherLoading }) => {
    return <Loading color="grey" show={routeLoading || otherLoading} showSpinner={false} />
}

export default connect(state => ({ routeLoading: state.data.loading.route, otherLoading: state.data.loading.other }), null)(LoadingBar);